const castleIndexes = ['199', '378', '358'];

export default castleIndexes;
